// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEnrollmentMatrixPatchDto
 */
export interface IEnrollmentMatrixPatchDto {
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixPatchDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixPatchDto
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixPatchDto
     */
    valid_to?: string | null;
}

/**
 * Check if a given object implements the IEnrollmentMatrixPatchDto interface.
 */
export function instanceOfIEnrollmentMatrixPatchDto(value: object): value is IEnrollmentMatrixPatchDto {
    return true;
}

export function IEnrollmentMatrixPatchDtoFromJSON(json: any): IEnrollmentMatrixPatchDto {
    return IEnrollmentMatrixPatchDtoFromJSONTyped(json, false);
}

export function IEnrollmentMatrixPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentMatrixPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
    };
}

export function IEnrollmentMatrixPatchDtoToJSON(json: any): IEnrollmentMatrixPatchDto {
    return IEnrollmentMatrixPatchDtoToJSONTyped(json, false);
}

export function IEnrollmentMatrixPatchDtoToJSONTyped(value?: IEnrollmentMatrixPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'priority': value['priority'],
        'valid_to': value['valid_to'],
    };
}

